import styled from '@emotion/styled';

export const SadaMeetCardWrapper = styled.div``;
